/**
 * Copyright 2022-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */
import { useHistory } from "react-router-dom";
import { ResourceExecutionStatus } from "~/generated/graphql";
import { PopoverControls } from "~/components";
import { useDisclosure } from "~/hooks";
import { ROUTES } from "~/routing/routes";
import { ResourceDetailsActionDetailsSidebar } from "./ResourceDetailsActionDetailsSidebar/ResourceDetailsActionDetailsSidebar";
import { ResourceDetailsActionLogs } from "./ResourceDetailsActionLogs";

type Props =
  | {
      isFutureAction: true;
      planId: string;
    }
  | {
      isFutureAction?: false;
      outputUri: string;
      resourceId: string;
      eventId: string;
      eventActionId: string;
      planId: string;
      actionName: string;
      resourceExecutionStatus: ResourceExecutionStatus;
    };

export function ResourceDetailsActionsTableActions(props: Props) {
  const { isFutureAction, planId } = props;

  const {
    isOpen: isActionLogModalOpen,
    close: closeActionLogModal,
    open: openActionLogModal,
  } = useDisclosure(false);

  const {
    isOpen: isActionDetailsSidebarOpen,
    close: closeActionDetailsSidebar,
    open: openActionDetailsSidebar,
  } = useDisclosure(false);

  const history = useHistory();

  return (
    <>
      <PopoverControls
        disabled={false}
        size="large"
        items={[
          {
            label: `Go to plan`,
            onClick: () => history.push(ROUTES.plans.generateDetails(planId)),
          },
          ...(!isFutureAction
            ? [
                {
                  label: `Report View`,
                  onClick: () => openActionDetailsSidebar(),
                  disabled:
                    props.resourceExecutionStatus ===
                      ResourceExecutionStatus.InProgress ||
                    props.resourceExecutionStatus ===
                      ResourceExecutionStatus.Pending,
                },
                {
                  label: `Action Log`,
                  onClick: () => openActionLogModal(),
                  disabled:
                    props.resourceExecutionStatus ===
                      ResourceExecutionStatus.InProgress ||
                    props.resourceExecutionStatus ===
                      ResourceExecutionStatus.Pending,
                },
              ]
            : []),
        ]}
      />
      {!isFutureAction && (
        <>
          <ResourceDetailsActionLogs
            outputUri={props.outputUri}
            isOpen={isActionLogModalOpen}
            close={closeActionLogModal}
          />
          <ResourceDetailsActionDetailsSidebar
            isOpen={isActionDetailsSidebarOpen}
            close={closeActionDetailsSidebar}
            eventId={props.eventId}
            eventActionId={props.eventActionId}
            resourceId={props.resourceId}
            actionName={props.actionName}
          />
        </>
      )}
    </>
  );
}
